module.exports = __webpack_public_path__ + "img/7.198db21f.png";